import { render, staticRenderFns } from "./AiTranslatePiece.vue?vue&type=template&id=97fb2d2e&scoped=true"
import script from "./AiTranslatePiece.vue?vue&type=script&lang=js"
export * from "./AiTranslatePiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb2d2e",
  null
  
)

export default component.exports